export default "__VITE_ASSET__CDInnyjs__"